import { Sentiment, SentimentEnum } from "../models/sentiment.model";
import { Box, Button, Divider, Grid, IconButton, Stack, Typography } from "@mui/material";
import { forwardRef, useImperativeHandle, Fragment } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import FormInputText from "../components/Form/FormInputText";
import FormSelection from "../components/Form/FormSelection";
import { titleStr } from "../lib/helper";
import { Delete } from "@mui/icons-material";

export default forwardRef(
  (
    props: {
      defaultValues?: Partial<Sentiment>;
    },
    ref: any
  ) => {
    const methods = useForm<Sentiment>({
      defaultValues: props.defaultValues,
    });
    const { handleSubmit, control, setError } = methods;
    console.log(props.defaultValues);
    useImperativeHandle(ref, () => ({
      onSubmit() {
        return new Promise((resolve, reject) => {
          handleSubmit(resolve, reject)();
        });
      },
    }));

    const { fields, append, remove } = useFieldArray({
      control,
      name: "keywords",
    });

    const sentimentTypeOptions = Object.entries(SentimentEnum).map(([key, value]) => ({
      label: titleStr(`${value}`),
      value: `${key}`,
    }));

    return (
      <Box
        component="form"
        sx={{
          "& .MuiTextField-root": { mt: 1, mb: 1 },
        }}
        autoComplete="off"
      >
        <Stack direction="column" spacing={2}>
          <Typography variant="h6">Sentiment Content</Typography>
          <Typography variant="body1">{props.defaultValues?.content}</Typography>
          <FormSelection
            noEmpty
            control={control}
            setError={setError}
            name={"type"}
            required
            label={titleStr("Sentiment Type")}
            options={sentimentTypeOptions}
          />
          <Divider />
          <Typography variant="h4">Sentiment Keywords</Typography>
          <Grid container spacing={2}>
            {fields?.map((keyword, index) => (
              <Fragment key={`${keyword.text}-${index}`}>
                <Grid item xs={5}>
                  <FormInputText name={`keywords.${index}.text`} control={control} setError={setError} label="Keyword" />
                </Grid>
                <Grid item xs={5}>
                  <FormSelection
                    noEmpty
                    control={control}
                    setError={setError}
                    name={`keywords.${index}.sentiment`}
                    required
                    label={titleStr("Sentiment Type")}
                    options={sentimentTypeOptions}
                  />
                </Grid>
                <Grid alignContent="center" item xs={2}>
                  <IconButton onClick={() => remove(index)}>
                    <Delete />
                  </IconButton>
                </Grid>
              </Fragment>
            ))}
            <Grid item xs={12}>
              <Button variant="contained" color="primary" onClick={() => append({ text: "", sentiment: SentimentEnum.positive, score: 1 })}>
                Add Keyword
              </Button>
            </Grid>
          </Grid>
        </Stack>
      </Box>
    );
  }
);
